import React, { useEffect, useState } from 'react'
import ProgressBarModal from './ProgressBarModal'
import { progressLoading } from '../../apiService'

const confirmOnUploading = e => {
  e.preventDefault()
  const confirmationMessage = 'คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้?'
  event.returnValue = confirmationMessage
  return confirmationMessage
}

export default () => {
  const [open, setOpen] = useState(false)
  const [progressData, setProgressData] = useState({})

  useEffect(() => {
    const cleanupProgress = progressLoading.onChange(({ detail: data }) => {
      setProgressData({ ...progressData, ...data })
    })

    return cleanupProgress
  }, [])

  useEffect(() => {
    if (progressData.open === false) {
      window.removeEventListener('beforeunload', confirmOnUploading)
      window.removeEventListener('unload', confirmOnUploading)
      setTimeout(() => setOpen(!!progressData.open), 500)
    } else {
      if (progressData.percent > 0 && progressData.percent <= 100) {
        window.addEventListener('beforeunload', confirmOnUploading)
        window.addEventListener('unload', confirmOnUploading)
      }
      setOpen(progressData.open)
    }
    // console.log(progressData)

    return () => {
      window.removeEventListener('beforeunload', confirmOnUploading)
      window.removeEventListener('unload', confirmOnUploading)
    }
  }, [progressData.open, progressData.percent])

  return <ProgressBarModal open={open} {...progressData} />
}
